import { ProfileFormData } from "./ProfileFormData";

export class PostSecondaryEducationFormData extends ProfileFormData {
    constructor(_applicantId: number, _pageId: string) {
        super(_applicantId, _pageId);
    }
    Institutions?: PostSecondaryEducation[];
    HasAttendedCollege?: boolean;

    toJSON() {
        return {
            applicantId: this.applicantId,
            pageId: this.pageId,
            Institutions: this.Institutions,
            HasAttendedCollege: this.HasAttendedCollege,
        };
    }
}

export class PostSecondaryEducation {
    ApplicantPostSecondaryId?: number;
    ApplicantCollegeId?: number;
    Id?: string;
    AmCollegeId?: number;
    Name?: string;
    DidGraduate?: boolean;
    DegreeId?: string;
    AttendedFrom?: Date;
    AttendedTo?: Date;
    EarnedCredits?: boolean;
    UploadUnofficialTranscript?: boolean;
    UnofficialTranscriptFileName?: string;
    IsManualEntry?: boolean;
    ManualAddress?: string;
    ManualCity?: string;
    ManualCounty?: string;
    ManualState?: string;
    ManualZip?: string;
    Edited?: boolean;
}
